export default __webpack_public_path__ + "static/media/loginIllustration.567c4b62.png";